import React, { Component } from 'react';
import './ERROR.scss';
class ERROR extends Component {
    render() {
        return (
            <div>
                <div className = "background-underlay-logo"></div>
                <div className = "error-page-content">
                    <h1 className = "error-page-title">OOPS!!</h1>
                    <div className = "error-page-content-body">
                        Looks like unable to connect the server. Please retry after sometime.
                    </div>
                    <div className = "error-page-fallback-link">
                        Please check our official website <a href = "https://enterprisebot.ai/" target="_blank" rel="noopener noreferrer">enterprisebot.ai</a> for other information.<br />
                    </div>
                </div>
            </div>
        )
    }
}

export default ERROR;
